var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2299",
    "data-name": "Group 2299",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M6.94,14.036c-.233.624-.43,1.2-.606,1.783a7.257,7.257,0,0,1,3.418-1.3,8,8,0,0,0,5.876-4.058L14.172,9l1.413-1.415,1-1a8.353,8.353,0,0,0,1.428-2.368C12.42,5.085,8.995,8.51,6.939,14.036ZM17,9l1,1a9.937,9.937,0,0,1-8,6.5Q6,17,5,22H3C4,16,6,2,21,2q-1.5,4.5-3,6Z",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit-icon.f1f3559fc0815ceae2dbecfad32a9ef5.svg";
export { ForwardRef as ReactComponent };